export const calcDistance = (curr, next) => Math.sqrt((Number(next.x) - Number(curr.x)) ** 2 + (Number(next.y) - Number(curr.y)) ** 2)
